import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login'
import createShop from '../views/create-shop'
import select from '../views/select'
import success from '../views/success'
import home from '../views/home'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/setshop',
    name: 'createShop',
    component: createShop
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Setshop.vue')
  },
  {
    path: '/select',
    name: 'select',
    component: select
  },
  {
    path: '/success',
    name: 'success',
    component: success
  },
  // 餐饮业
  {
    path: '/catering',
    name: 'catering-index',
    component: () => import(/* webpackChunkName: "catering-index" */ '@/views/catering/index.vue')
  },
  {
    path: '/catering/register',
    name: 'catering-register',
    component: () => import(/* webpackChunkName: "catering-register" */ '@/views/catering/register.vue')
  },
  {
    path: '/catering/create',
    name: 'create-store',
    component: () => import(/* webpackChunkName: "select-template" */ '@/views/catering/create-store.vue')
  },
  // 美业
  {
    path: '/mei',
    name: 'beauty-index',
    component: () => import(/* webpackChunkName: "beauty-index" */ '@/views/beauty-industry/index.vue')
  },
  {
    path: '/mei/register',
    name: 'beauty-register',
    component: () => import(/* webpackChunkName: "beauty-register" */ '@/views/beauty-industry/register.vue')
  },
  {
    path: '/mei/create',
    name: 'beauty-create-store',
    component: () => import(/* webpackChunkName: "beauty-create" */ '@/views/beauty-industry/create-store.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
